import { render, staticRenderFns } from "./refund-info.vue?vue&type=template&id=27444a38&scoped=true"
import script from "./refund-info.vue?vue&type=script&lang=js"
export * from "./refund-info.vue?vue&type=script&lang=js"
import style0 from "./refund-info.vue?vue&type=style&index=0&id=27444a38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27444a38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27444a38')) {
      api.createRecord('27444a38', component.options)
    } else {
      api.reload('27444a38', component.options)
    }
    module.hot.accept("./refund-info.vue?vue&type=template&id=27444a38&scoped=true", function () {
      api.rerender('27444a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/express/components/refund-info.vue"
export default component.exports